<template>
  <div>
    <div>
      <!-- 出库 -->
       <SearchCollapse @update-height="getHeight" :formItemsLength="13">
      <div class="formBox margbot" ref="searchBox">
        <el-form :inline="true" :model="formData"  size="mini" label-width="80px">
          <div class="formItemBox">
          <el-form-item label="出库单号:">
            <el-input class="ipt" v-model="formData.outstockNo" placeholder="请输入出库单号" size="mini" >
            </el-input>
          </el-form-item>
          <el-form-item label="一级货主:">
            <el-select size="mini" filterable clearable placeholder="请选择一级货主" v-model="formData.primaryCustomerTaxId">
              <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select size="mini" clearable filterable placeholder="请选择二级货主" v-model="formData.customerTaxId">
              <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出库时间:">
            <div style="display: flex;">
            <el-date-picker v-model="formData.outstockDateStart" size="mini" type="datetime" placeholder="选择出库时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            -
            <el-date-picker v-model="formData.outstockDateEnd" size="mini" placeholder="选择出库时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="客户单号:">
            <el-input class="ipt" v-model="formData.outBillNo" placeholder="请输入客户单号" size="mini" >
            </el-input>
          </el-form-item>
          <el-form-item label="提货单号:">
            <el-input class="ipt" v-model="formData.billNo" placeholder="请输入提货单号" size="mini" >
            </el-input>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择" filterable size="mini">
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select v-model="formData.placeOfOrigin" @change='steelMillNameChange' clearable placeholder="请选择" filterable size="mini">
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:">
            <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择" filterable size="mini">
              <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable size="mini">
              <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆号牌:">
            <el-input class="ipt" v-model="formData.outstockPlateNumber" placeholder="请输入车号" size="mini" ></el-input>
          </el-form-item>
          <el-form-item label="创建时间:">
            <div style="display: flex;">
            <el-date-picker v-model="formData.createTimeStart" size="mini" type="datetime" placeholder="请选择创建时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            -
            <el-date-picker v-model="formData.createTimeEnd" size="mini" placeholder="请选择创建时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="提货客户:">
            <el-input v-model="formData.pickupCustomerName" maxlength="50" placeholder="请输入提货客户"  size="mini"></el-input>

          </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" btnCode="00ZP007B008" v-if="btnFlg[7]">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" btnCode="00ZP007B009" v-if="btnFlg[8]">重置
            </el-button>
            <el-button type="primary" size="mini" @click="revokeBtn" btnCode="00ZP007B00A" v-if="btnFlg[9]">撤销
            </el-button>
            <el-button type="primary" size="mini" @click="daochu" btnCode="00ZP007B00B" v-if="btnFlg[10]">导出</el-button>
            <el-button type="primary" size="mini" @click="beizhuBtn"  btnCode="00ZM0E0J00" v-if="btnFlg[47]">记录备注
                  </el-button>
          </el-form-item>
          <el-form-item>
            <span>
              总吨数：
              <span style="color: red">{{ allWeight }}</span> &nbsp;吨
            </span>
            <span style="margin-left: 20px">
              总件数：
              <span style="color: red">{{ allNumber }}</span> &nbsp;件
            </span>
          </el-form-item>
        </el-form>
      </div>
      </SearchCollapse>
      <div :style="{height:h}">
        <el-table border center bordersize="mini" :data="tableData" height="100%" style="width:100%" class="tableComent" size="mini" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @selection-change="selectGoods">
          <el-table-column type="selection" align="center" width="40"></el-table-column>
          <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
          <el-table-column align="center" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" @click="lookGoods(scope.row)" size="mini" v-show="scope.row.path">提货函</el-button>
              <el-button type="text" @click="lookMessage(scope.row)" size="mini">人车信息</el-button>
              <el-button type="text" @click="lookBD(scope.row)" size="mini" v-if="Number(scope.row.weighingWeight / 1) > 0">磅单</el-button>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="billCreateTime" label="提单时间" width="180">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockUserName" label="出库人" width="120">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="billNo" label="提货单号" width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outBillNo" label="客户单号" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockPlateNumber" label="车号" width="200">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="220">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="pickupCustomerName" label="提货客户" width="220">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="120">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="placeOfOrigin" label="产地" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" width="180">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="过磅净重时间" width="180">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="180"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" width="200"></el-table-column>
          <el-table-column label="司机确认时间" prop="driverConfirmDate" width="180"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockNo" label="出库单号" width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" width="180"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockDate" label="出库时间" width="180"></el-table-column>
          <el-table-column prop="recordRemark" label="记录备注" :show-overflow-tooltip="true" align="center" width="150"></el-table-column>

        </el-table>
      </div>
      <div class="pags">
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
      </div>
    </div>
    <!-- 人车信息 -->
    <rcDialog v-if="RCVisible" :RCVisible.sync='RCVisible' :identityNo="identityNo" :vhcNo="vhcNo" :driverName="driverName" :telephone="telephone"></rcDialog>
    <!-- 查看磅单 -->
    <bdDialog v-if="BDVisible" :BDVisible.sync='BDVisible' :outstockSummaryId="outstockSummaryId"></bdDialog>
  <!-- 备注 -->
  <bei-zhu v-if="beizhuMark"  @shuaxin="chaxun" :beizhuMark.sync="beizhuMark" :beizhuName="beizhuName" :selectId="selectId"></bei-zhu>

  </div>
</template>

<script>
import {
  getRelationCustomer,
  JfgetOutStockExpList,
  getVirtualBalingList,
  JfdeleteOutStockExp,
  getSBillFileUrl,
  getOutStockExpNumber
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  dateTimeFormat
} from '@/utils/util'
import {
  exportExcel
} from '@/utils/fileDown.js'
import rcDialog from '../../jfChuKuGuanLi/dialog/RCdialog.vue'
import bdDialog from '../../jfChuKuGuanLi/dialog/BDImg.vue'
import beiZhu from './beizhu.vue'
import SearchCollapse from '@/components/common/SearchCollapse.vue'

export default {
  name: 'CKRecord',
  components: {
    beiZhu,
    rcDialog,
    bdDialog,
    SearchCollapse
  },
  data () {
    return {
      beizhuMark: false,
      beizhuName: '出库记录JF',
      selectList: [],
      selectId: [],
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      formData: {
        outstockNo: '',
        outstockDateStart: '',
        outstockDateEnd: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        outstockPlateNumber: '',
        productType: '',
        placeOfOrigin: '',
        specification: '',
        model: '',
        billNo: '',
        outBillNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        pickupCustomerName: ''
      },
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      btnArr: [
        '00ZP007B001',
        '00ZP007B002',
        '00ZP007B003',
        '00ZP007B004',
        '00ZP007B005',
        '00ZP007B006',
        '00ZP007B007',
        '00ZP007B008',
        '00ZP007B009',
        '00ZP007B00A',
        '00ZP007B00B',
        '00ZP007B00C',
        '00ZP007B00D',
        '00ZP007B00E',
        '00ZP007B00F',
        '00ZP007B00G',
        '00ZP007B00H',
        '00ZP007B00I',
        '00ZP007B00J',
        '00ZP007B00K',
        '00ZP007B00L',
        '00ZP007B00M',
        '00ZP007B00N',
        '00ZP007B00O',
        '00ZP007B00P',
        '00ZP007B00Q',
        '00ZP007B00R',
        '00ZP007B00S',
        '00ZP007B00T',
        '00ZP007B00U',
        '00ZM0E0100',
        '00ZM0E0200',
        '00ZM0E0300',
        '00ZM0E0400',
        '00ZM0E0500',
        '00ZM0E0600',
        '00ZM0E0700',
        '00ZM0E0800',
        // '00ZM0E0900',/
        '00ZM0E0A00',
        '00ZM0E0B00',
        '00ZM0E0C00',
        '00ZM0E0D00',
        '00ZM0E0E00',
        '00ZM0E0F00',
        '00ZM0E0G00',
        '00ZM0E0H00',
        '00ZM0E0I00',
        '00ZM0E0J00'
      ],
      btnFlg: [],
      tableData: [],
      HZData: [],
      h: 500,
      xuanzhongArr: null,
      daoruMark: false,
      isDisable1: false,
      selectListId: [],
      selectionData: [],
      RCVisible: false,
      vhcNo: '',
      identityNo: '',
      telephone: '',
      driverName: '',
      BDVisible: false,
      outstockSummaryId: '',
      allWeight: 0,
      allNumber: 0
    }
  },
  props: {
    CKVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    beizhuBtn () {
      if (this.selectList.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.beizhuMark = true
        this.selectId = []
        this.selectList.forEach(item => {
          this.selectId.push(item.outstockSummaryId)
        })
      }
    },
    // 总吨数
    getOutStockExpNumber () {
      getOutStockExpNumber({
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        outstockPlateNumber: this.formData.outstockPlateNumber,
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        outstockNo: this.formData.outstockNo,
        outstockDateStart: this.formData.outstockDateStart,
        outstockDateEnd: this.formData.outstockDateEnd,
        billNo: this.formData.billNo,
        outBillNo: this.formData.outBillNo,
        createTimeStart: this.formData.createTimeStart,
        createTimeEnd: this.formData.createTimeEnd,
        pickupCustomerName: this.formData.pickupCustomerName
      }).then(res => {
        console.log(res)
        if (res.length != 0) {
          this.allWeight = parseFloat(res.totalAllWeight.toFixed(6))
          this.allNumber = res.totalNumber
        } else {
          this.allWeight = 0
          this.allNumber = 0
        }
      })
        .catch(error => {
          this.message.error(error.message)
        })
    },
    // 人车信息
    lookMessage (row) {
      this.RCVisible = true
      this.identityNo = row.idNumber
      this.vhcNo = row.outstockPlateNumber
      this.telephone = row.telephone
      this.driverName = row.driverName
    },
    // 提货函
    lookGoods (row) {
      if (row.path) {
        let formData = new FormData()
        formData.append('url', row.path)
        getSBillFileUrl(formData).then(res => {
          this.$router.push({
            name: 'Pdf',
            query: {
              path: res
            }
          })
        })
      }
    },
    // 磅单
    lookBD (row) {
      this.BDVisible = true
      this.outstockSummaryId = row.outstockSummaryId
    },
    // 列表查询
    JfgetOutStockExpLists () {
      JfgetOutStockExpList({
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        outstockPlateNumber: this.formData.outstockPlateNumber,
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        outstockNo: this.formData.outstockNo,
        outstockDateStart: this.formData.outstockDateStart,
        outstockDateEnd: this.formData.outstockDateEnd,
        billNo: this.formData.billNo,
        outBillNo: this.formData.outBillNo,
        createTimeStart: this.formData.createTimeStart,
        createTimeEnd: this.formData.createTimeEnd,
        pickupCustomerName: this.formData.pickupCustomerName
      })
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.tableData.forEach(item => {
            item.allWeight = parseFloat(Number(item.allWeight).toFixed(6))
            item.weight = parseFloat(Number(item.weight).toFixed(6))
          })
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    selectGoods (selection) {
      this.selectList = []
      this.selectList = selection
    },
    handleClicktab (tab, event) {
      console.log(tab, event)
      // this.getControlAuditLists()
    },
    chaxun () {
      this.JfgetOutStockExpLists()
      this.getOutStockExpNumber()
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.outstockPlateNumber = ''
      this.formData.productType = ''
      this.formData.placeOfOrigin = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.outstockNo = ''
      this.formData.outstockDateStart = ''
      this.formData.outstockDateEnd = ''
      this.formData.billNo = ''
      this.formData.outBillNo = ''
      this.formData.createTimeStart = ''
      this.formData.createTimeEnd = ''
      this.formData.pickupCustomerName = ''
      this.JfgetOutStockExpLists()
      this.getVirtualBalingList()
      this.getOutStockExpNumber()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/stockExpInfo/exportOutStockExpList', {
          ...this.formData,
          instockStatus: '1'
        },
        '出库记录表'
      )
    },
    // 撤销
    revokeBtn () {
      if (this.selectList.length != 1) {
        this.$message.error('请选择一条数据进行撤销')
      } else {
        this.$confirm('撤销后数据不可恢复，确定撤销吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.tabLoading = true
          JfdeleteOutStockExp({
            outstockSummaryId: this.selectList[0].outstockSummaryId
          })
            .then((res) => {
              this.tabLoading = false
              this.$message.success('撤销成功')
              this.JfgetOutStockExpLists(this.formData)
              this.getOutStockExpNumber(this.formData)
            })
            .catch((err) => {
              this.tabLoading = false
              // console.log(err.message)
              this.$message.error(err.message)
            })
        }).catch(() => { })
      }
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetOutStockExpLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetOutStockExpLists()
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          console.log(res)
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = pH - h - 220 + 'px'
      })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/recordQuery')
    this.getRelationCustomerS()
    this.JfgetOutStockExpLists()
    this.getOutStockExpNumber()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    this.getHeight()
  }
}

</script>

<style lang="less" scoped>
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

</style>
